var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedStateFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 339,
    viewBox: "0 0 512 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H512V25.7872H0V0Z",
    fill: "#BC133E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.7871H512V51.5743H0V25.7871Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.5742H512V77.3614H0V51.5742Z",
    fill: "#BC133E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 77.2837H512V103.071H0V77.2837Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 103.071H512V128.858H0V103.071Z",
    fill: "#BC133E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 128.858H512V154.646H0V128.858Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 154.646H512V180.433H0V154.646Z",
    fill: "#BC133E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 180.355H512V206.142H0V180.355Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 206.142H512V231.929H0V206.142Z",
    fill: "#BC133E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 231.929H512V257.716H0V231.929Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 257.716H512V283.503H0V257.716Z",
    fill: "#BC133E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 283.426H512V309.213H0V283.426Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 309.213H512V335H0V309.213Z",
    fill: "#BC133E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H267.215V179.887H0V0Z",
    fill: "#253583"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1305 7.63477L23.4874 14.4906H30.9642L24.8689 18.7755L27.2258 25.6313L21.1305 21.3464L15.0353 25.6313L17.3921 18.7755L11.2969 14.4906H18.7737L21.1305 7.63477Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1542 7.63477L68.4297 14.4906H75.9878L69.8926 18.7755L72.2494 25.6313L66.1542 21.3464L60.0589 25.6313L62.3345 18.7755L56.2393 14.4906H63.7974L66.1542 7.63477Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.096 7.63477L113.453 14.4906H121.011L114.916 18.7755L117.191 25.6313L111.096 21.3464L105.001 25.6313L107.357 18.7755L101.262 14.4906H108.82L111.096 7.63477Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.119 7.63477L158.476 14.4906H165.953L159.858 18.7755L162.215 25.6313L156.119 21.3464L150.024 25.6313L152.381 18.7755L146.286 14.4906H153.762L156.119 7.63477Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.143 7.63477L203.419 14.4906H210.977L204.881 18.7755L207.238 25.6313L201.143 21.3464L195.048 25.6313L197.323 18.7755L191.228 14.4906H198.786L201.143 7.63477Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M246.085 7.63477L248.442 14.4906H256L249.905 18.7755L252.18 25.6313L246.085 21.3464L240.071 25.6313L242.347 18.7755L236.251 14.4906H243.81L246.085 7.63477Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6422 25.6309L45.9991 32.4867H53.5572L47.4619 36.6937L49.7375 43.5495L43.6422 39.3425L37.547 43.5495L39.9038 36.6937L33.8086 32.4867H41.3667L43.6422 25.6309Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6652 25.6309L91.022 32.4867H98.4988L92.4036 36.6937L94.7604 43.5495L88.6652 39.3425L82.57 43.5495L84.9268 36.6937L78.8315 32.4867H86.3896L88.6652 25.6309Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.689 25.6309L136.046 32.4867H143.523L137.428 36.6937L139.784 43.5495L133.689 39.3425L127.594 43.5495L129.951 36.6937L123.855 32.4867H131.332L133.689 25.6309Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M178.712 25.6309L180.988 32.4867H188.546L182.451 36.6937L184.808 43.5495L178.712 39.3425L172.617 43.5495L174.893 36.6937L168.797 32.4867H176.355L178.712 25.6309Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M223.655 25.6309L226.012 32.4867H233.57L227.475 36.6937L229.75 43.5495L223.655 39.3425L217.56 43.5495L219.917 36.6937L213.821 32.4867H221.379L223.655 25.6309Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1305 44.3291L23.4874 51.1849H30.9642L24.8689 55.3919L27.2258 62.2477L21.1305 58.0407L15.0353 62.2477L17.3921 55.3919L11.2969 51.1849H18.7737L21.1305 44.3291Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1542 44.3291L68.4297 51.1849H75.9878L69.8926 55.3919L72.2494 62.2477L66.1542 58.0407L60.0589 62.2477L62.3345 55.3919L56.2393 51.1849H63.7974L66.1542 44.3291Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.096 44.3291L113.453 51.1849H121.011L114.916 55.3919L117.191 62.2477L111.096 58.0407L105.001 62.2477L107.357 55.3919L101.262 51.1849H108.82L111.096 44.3291Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M156.119 44.3291L158.476 51.1849H165.953L159.858 55.3919L162.215 62.2477L156.119 58.0407L150.024 62.2477L152.381 55.3919L146.286 51.1849H153.762L156.119 44.3291Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M201.143 44.3291L203.419 51.1849H210.977L204.881 55.3919L207.238 62.2477L201.143 58.0407L195.048 62.2477L197.323 55.3919L191.228 51.1849H198.786L201.143 44.3291Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M246.085 44.3291L248.442 51.1849H256L249.905 55.3919L252.18 62.2477L246.085 58.0407L240.071 62.2477L242.347 55.3919L236.251 51.1849H243.81L246.085 44.3291Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6422 62.2476L45.9991 69.1034H53.5572L47.4619 73.3883L49.7375 80.2441L43.6422 76.0371L37.547 80.2441L39.9038 73.3883L33.8086 69.1034H41.3667L43.6422 62.2476Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6652 62.2476L91.022 69.1034H98.4988L92.4036 73.3883L94.7604 80.2441L88.6652 76.0371L82.57 80.2441L84.9268 73.3883L78.8315 69.1034H86.3896L88.6652 62.2476Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M133.689 62.2476L136.046 69.1034H143.523L137.428 73.3883L139.784 80.2441L133.689 76.0371L127.594 80.2441L129.951 73.3883L123.855 69.1034H131.332L133.689 62.2476Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M178.712 62.2476L180.988 69.1034H188.546L182.451 73.3883L184.808 80.2441L178.712 76.0371L172.617 80.2441L174.893 73.3883L168.797 69.1034H176.355L178.712 62.2476Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M223.655 62.2476L226.012 69.1034H233.57L227.475 73.3883L229.75 80.2441L223.655 76.0371L217.56 80.2441L219.917 73.3883L213.821 69.1034H221.379L223.655 62.2476Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1305 80.9448L23.4874 87.8006H30.9642L24.8689 92.0855L27.2258 98.9413L21.1305 94.7344L15.0353 98.9413L17.3921 92.0855L11.2969 87.8006H18.7737L21.1305 80.9448Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1542 80.9448L68.4297 87.8006H75.9878L69.8926 92.0855L72.2494 98.9413L66.1542 94.7344L60.0589 98.9413L62.3345 92.0855L56.2393 87.8006H63.7974L66.1542 80.9448Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M111.096 80.9448L113.453 87.8006H121.011L114.916 92.0855L117.191 98.9413L111.096 94.7344L105.001 98.9413L107.357 92.0855L101.262 87.8006H108.82L111.096 80.9448Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M156.119 80.9448L158.476 87.8006H165.953L159.858 92.0855L162.215 98.9413L156.119 94.7344L150.024 98.9413L152.381 92.0855L146.286 87.8006H153.762L156.119 80.9448Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M201.143 80.9448L203.419 87.8006H210.977L204.881 92.0855L207.238 98.9413L201.143 94.7344L195.048 98.9413L197.323 92.0855L191.228 87.8006H198.786L201.143 80.9448Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M246.085 80.9448L248.442 87.8006H256L249.905 92.0855L252.18 98.9413L246.085 94.7344L240.071 98.9413L242.347 92.0855L236.251 87.8006H243.81L246.085 80.9448Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6422 98.9414L45.9991 105.797H53.5572L47.4619 110.082L49.7375 116.938L43.6422 112.653L37.547 116.938L39.9038 110.082L33.8086 105.797H41.3667L43.6422 98.9414Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6652 98.9414L91.022 105.797H98.4988L92.4036 110.082L94.7604 116.938L88.6652 112.653L82.57 116.938L84.9268 110.082L78.8315 105.797H86.3896L88.6652 98.9414Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M133.689 98.9414L136.046 105.797H143.523L137.428 110.082L139.784 116.938L133.689 112.653L127.594 116.938L129.951 110.082L123.855 105.797H131.332L133.689 98.9414Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M178.712 98.9414L180.988 105.797H188.546L182.451 110.082L184.808 116.938L178.712 112.653L172.617 116.938L174.893 110.082L168.797 105.797H176.355L178.712 98.9414Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M223.655 98.9414L226.012 105.797H233.57L227.475 110.082L229.75 116.938L223.655 112.653L217.56 116.938L219.917 110.082L213.821 105.797H221.379L223.655 98.9414Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1305 117.639L23.4874 124.495H30.9642L24.8689 128.78L27.2258 135.636L21.1305 131.351L15.0353 135.636L17.3921 128.78L11.2969 124.495H18.7737L21.1305 117.639Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1542 117.639L68.4297 124.495H75.9878L69.8926 128.78L72.2494 135.636L66.1542 131.351L60.0589 135.636L62.3345 128.78L56.2393 124.495H63.7974L66.1542 117.639Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M111.096 117.639L113.453 124.495H121.011L114.916 128.78L117.191 135.636L111.096 131.351L105.001 135.636L107.357 128.78L101.262 124.495H108.82L111.096 117.639Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M156.119 117.639L158.476 124.495H165.953L159.858 128.78L162.215 135.636L156.119 131.351L150.024 135.636L152.381 128.78L146.286 124.495H153.762L156.119 117.639Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M201.143 117.639L203.419 124.495H210.977L204.881 128.78L207.238 135.636L201.143 131.351L195.048 135.636L197.323 128.78L191.228 124.495H198.786L201.143 117.639Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M246.085 117.639L248.442 124.495H256L249.905 128.78L252.18 135.636L246.085 131.351L240.071 135.636L242.347 128.78L236.251 124.495H243.81L246.085 117.639Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6422 135.636L45.9991 142.492H53.5572L47.4619 146.699L49.7375 153.554L43.6422 149.347L37.547 153.554L39.9038 146.699L33.8086 142.492H41.3667L43.6422 135.636Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6652 135.636L91.022 142.492H98.4988L92.4036 146.699L94.7604 153.554L88.6652 149.347L82.57 153.554L84.9268 146.699L78.8315 142.492H86.3896L88.6652 135.636Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M133.689 135.636L136.046 142.492H143.523L137.428 146.699L139.784 153.554L133.689 149.347L127.594 153.554L129.951 146.699L123.855 142.492H131.332L133.689 135.636Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M178.712 135.636L180.988 142.492H188.546L182.451 146.699L184.808 153.554L178.712 149.347L172.617 153.554L174.893 146.699L168.797 142.492H176.355L178.712 135.636Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M223.655 135.636L226.012 142.492H233.57L227.475 146.699L229.75 153.554L223.655 149.347L217.56 153.554L219.917 146.699L213.821 142.492H221.379L223.655 135.636Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1305 154.333L23.4874 161.189H30.9642L24.8689 165.396L27.2258 172.252L21.1305 168.045L15.0353 172.252L17.3921 165.396L11.2969 161.189H18.7737L21.1305 154.333Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1542 154.333L68.4297 161.189H75.9878L69.8926 165.396L72.2494 172.252L66.1542 168.045L60.0589 172.252L62.3345 165.396L56.2393 161.189H63.7974L66.1542 154.333Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M111.096 154.333L113.453 161.189H121.011L114.916 165.396L117.191 172.252L111.096 168.045L105.001 172.252L107.357 165.396L101.262 161.189H108.82L111.096 154.333Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M156.119 154.333L158.476 161.189H165.953L159.858 165.396L162.215 172.252L156.119 168.045L150.024 172.252L152.381 165.396L146.286 161.189H153.762L156.119 154.333Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M201.143 154.333L203.419 161.189H210.977L204.881 165.396L207.238 172.252L201.143 168.045L195.048 172.252L197.323 165.396L191.228 161.189H198.786L201.143 154.333Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M246.085 154.333L248.442 161.189H256L249.905 165.396L252.18 172.252L246.085 168.045L240.071 172.252L242.347 165.396L236.251 161.189H243.81L246.085 154.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStateFlag);
export default __webpack_public_path__ + "static/media/united_state_flag.33b0b350abd8f03b7bc884ffcd8c12fa.svg";
export { ForwardRef as ReactComponent };